import SelectContianer from '../components/store/SelectContianer';
export default {
  components: { SelectContianer },
  props: ['showChildSelector'],
  data() {
    return {
      showChildSelect: false,
    };
  },
  computed: {
    languages() {
      return this.$store.state.store.languages;
    },
  },
  watch: {
    showChildSelector(newVal) {
      // if(newVal){
      //     setTimeout(()=>{
      //         this.showChildSelect = true;
      //     },100)
      // }else{
      //     this.showChildSelect = false;
      // }
      this.showChildSelect = newVal;
    },
  },
  methods: {
    close() {
      this.$emit('closeSelecter');
    },
  },
};
